import { TOGGLE_LEGEND, OPEN_MOBILE_MAP, CLOSE_MOBILE_MAP } from '../constants';

const initialState = {
  legendOpened: false,
  mobileMapOpened: false,
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_LEGEND:
      return {
        ...state,
        legendOpened:
          action.payload !== undefined ? action.payload : !state.legendOpened,
      };
    case OPEN_MOBILE_MAP:
      return {
        ...state,
        mobileMapOpened: true,
      };
    case CLOSE_MOBILE_MAP:
      return {
        ...state,
        mobileMapOpened: false,
      };
    default:
      return state;
  }
};

export default uiReducer;
